var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[_c('div',{staticClass:"step__icon-container"},[_c('div',{class:[
				'step__icon',
				{
					'step__icon--active': _vm.isCurrent,
					'step__icon--filled': _vm.isCompleted,
				} ]},[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isCompleted)?_c('ZyroSvg',{attrs:{"name":"check-mark"}}):_c('span',{staticClass:"step__icon-text"},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)],1)]),_c('div',{staticClass:"step__status",class:{ 'step__status--filled': _vm.isCompleted }})])}
var staticRenderFns = []

export { render, staticRenderFns }